<template>
  <b-container fluid>
    <div class="iq-card mt-3 px-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title py-3">
          <!-- eslint-disable-next-line vue/no-parsing-error -->
          <h6 class="card-title"> <b-link :to="{ name: 'MasterTank' }">< Back</b-link> </h6>
          <h4 class="card-title">{{ TankHeaderData.tahdName }} Detail</h4>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right my-2">
              <button-options :access="'master_tank_detail'" :hideAdd="false" :hideDetail="true"
                :isRefreshEnabled="true" :isRefreshed="isRefreshed" @onAddItemClicked="openAddForm"
                @onRefreshed="getData('Refreshed')" />
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="iq-card-body">
        <b-row>
          <b-col md="12">
            <div class="table-responsive">
              <b-table striped hover fixed head-variant="dark" show-empty responsive :busy="isLoading" :fields="fields"
                :items="canRead('master_tank_detail') ? data : []"
                style="border-radius: 10px; overflow: scroll; max-height: 500px;">
                <template v-slot:table-busy="">
                  <div class="text-center text-danger my-2">
                    <b-spinner variant="success" size="sm" class="align-middle"></b-spinner>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="text-center">
                    <button-options :access="'master_tank_detail'" :hideAdd="true" :hideDelete="false"
                      :hideDetail="true" :hideEdit="false" @onDeleteClicked="openDelete(data.item)"
                      @onEditClicked="openEdit(data.item)" />
                  </div>
                </template>
              </b-table>

              <b-pagination v-model="pagination.current" :per-page="pagination.pageSize"
                :total-rows="pagination.totalSize" @change="onPageChanged"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="displayForm">
        <div class="iq-card mb-0" style="min-width: 300px;">
          <div class="iq-card-header d-flex justify-content-between">
            <div class="iq-header-title">
              <h4 class="card-title" v-if="!current.tadtId">Add New Tank Detail</h4>
              <h4 class="card-title" v-if="current.tadtId">Edit Tank Detail</h4>
            </div>
          </div>
          <div class="iq-card-body">
            <div class="row mb-3">
              <div role="group" class="form-group col-md-6">
                <label for="tadtHeight" class="d-block form-label text-left">
                  Tank Height:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-input required class="form-control" type="number" step="0.01" id="tadtHeight" placeholder="Tank Height"
                      v-model="current.tadtHeight" :class="errors.tadtHeight ? 'is-invalid' : ''" />
                    <b-form-invalid-feedback v-if="errors.tadtHeight">
                      {{ Object.values(errors.tadtHeight) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>

              <div role="group" class="form-group col-md-6">
                <label for="tadtHeight" class="d-block form-label text-left">
                  Tank Volume:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-input required class="form-control" type="number" step="0.01" id="tadtVolume" placeholder="Tank Volume"
                      v-model="current.tadtVolume" :class="errors.tadtVolume ? 'is-invalid' : ''" />
                    <b-form-invalid-feedback v-if="errors.tadtVolume">
                      {{ Object.values(errors.tadtVolume) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>

              <div role="group" class="form-group col-md-6">
                <label for="tadtWeight" class="d-block form-label text-left">
                  Tank Weight:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-input required class="form-control" type="number" step="0.01" id="tadtWeight" placeholder="Tank Weight"
                      v-model="current.tadtWeight" :class="errors.tadtWeight ? 'is-invalid' : ''" />
                    <b-form-invalid-feedback v-if="errors.tadtWeight">
                      {{ Object.values(errors.tadtWeight) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <b-button @click="onCancel" class="mr-1" size="sm" :disabled="isSubmit" variant="outline-danger">
                <div class="mx-2">Cancel</div>
              </b-button>
              <b-button @click="onSubmitClicked" :disabled="isSubmit" variant="primary" size="sm" class="ml-1">
                <div class="mx-2">
                  <i v-if="isSubmit" class="ri-loader-line"></i>
                  Submit
                </div>
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="displayDeletion">
        <delete-item :isSubmit="isSubmit" @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion" />
      </b-modal>
    </div>
  </b-container>
</template>

<script>

import DeleteItem from '@/components/directives/delete-item';
import ButtonOptions from '@/components/directives/button-options';
import TankHeaderSvc from '@/services/TankHeaderSvc';
import TankDetailSvc from '@/services/TankDetailSvc';
import CompanySvc from '@/services/CompanySvc';

import requestBuilder from '@/util/request.builder';

export default {
  name: 'MasterTankDetail',
  components: {
    DeleteItem, ButtonOptions,
  },
  data() {
    return {
      TankHeader: new TankHeaderSvc(),
      TankDetail: new TankDetailSvc(),
      TankHeaderData: {},
      companies: [],
      current: {},
      data: [],
      displayDeletion: false,
      displayForm: false,
      errors: {},
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
      filter: {
        tadtTahdId: this.$route.params.id,
      },
      fields: [
        {
          key: 'tadtHeight',
          label: 'Tank Height',
          class: 'text-left',
        },
        {
          key: 'tadtVolume',
          label: 'Tank Volume',
          class: 'text-left',
        },
        {
          key: 'tadtWeight',
          label: 'Tank Weight',
          class: 'text-left',
        },
        {
          key: 'tadtTahd.tahdName',
          label: 'Tank Header',
          class: 'text-left',
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
        },
      ],
    };
  },
  methods: {
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const deleteResponse = await this.TankDetail.delete(data.tadtId);
        if (deleteResponse.status.error === 0) {
          this.$toast.success(notification);
          this.displayDeletion = false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(deleteResponse.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      try {
        this.isLoading = true;
        this.isRefreshed = true;

        const TankHeaderResponse = await this.TankDetail.getAll({
          ...requestBuilder.buildFilters(this.pagination, this.filter),
        });

        const Data = TankHeaderResponse.data;

        this.data = Data;

        this.pagination.totalSize = TankHeaderResponse.pagination.totalData;
        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        console.error('get data error : ', e);
        this.$toast.error('Something wrong when fetching data');
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.current = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Tank Detail Deleted', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    async onSubmitClicked() {
      try {
        this.errors = {};
        this.isSubmit = true;

        const Data = {
          tadtHeight: this.current.tadtHeight,
          tadtVolume: this.current.tadtVolume,
          tadtWeight: this.current.tadtWeight,
          tadtTahdId: this.$route.params.id,
        };

        if (Data.tadtHeight === null || Data.tadtHeight === undefined) {
          this.errors.tadtHeight = ['Height is required'];
        }

        if (Data.tadtVolume === null || Data.tadtVolume === undefined) {
          this.errors.tadtVolume = ['Volume is required'];
        }

        if (Data.tahdWeight === null || Data.tahdWeight === undefined) {
          this.errors.tahdWeight = ['Weight is required'];
        }

        if (Object.keys(this.errors).length > 0) {
          return;
        }

        if (!this.current.tadtId) { // jika tidak ada tadtId maka create
          const createResponse = await this.TankDetail.create(Data);

          if (createResponse.status.error === 0) {
            await this.getData('Success');
            this.current = {};
          } else {
            this.$toast.error('Error when saving data');
          }
        } else { // jika ada tadtId maka update
          const updateResponse = await this.TankDetail.update(this.current.tadtId, Data);

          if (updateResponse.status.error === 0) {
            await this.getData('Success');
            this.current = {};
          } else {
            this.$toast.error('Error when Update data');
          }
        }
        this.displayForm = false;
      } catch (e) {
        this.displayForm = false;
        this.$toast.error('Error when submiting data');
        console.error('onSubmitClicked error : ', e);
      } finally {
        this.isSubmit = false;
      }
    },
    openAddForm() {
      this.current = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openEdit(data) {
      this.displayForm = true;
      this.current = { ...this._.find(this.data, (v) => v.tadtId === data.tadtId) };
    },
  },
  async mounted() {
    const TankHeaderResponse = await this.TankHeader.get(this.$route.params.id);
    this.TankHeaderData = TankHeaderResponse.data[0];
    await this.getData();

    const companyResponse = await CompanySvc.getCompanies({ params: { max: 100 } });
    this.companies = companyResponse.data.data.map((comp) => ({ value: comp.compId, text: comp.compName }));
    this.companies = [...this.companies, { value: null, text: 'All' }];
  },
};
</script>
